var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.component)?_c(_vm.params.component,_vm._b({ref:"modal",tag:"component"},'component',_vm.params.props,false)):_vm._e(),_vm._v(" "),_c('div',{ref:"container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }